var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-field',_vm._l((_vm.grades),function(grade){return _c('b-radio-button',{key:grade.text,staticClass:"is-expanded is-fullwidth",attrs:{"disabled":_vm.disabled,"native-value":grade.points},model:{value:(_vm.points),callback:function ($$v) {_vm.points=$$v},expression:"points"}},[_c('span',[_vm._v(_vm._s(grade.text))])])}))],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-565a3017","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/survey/AnswerScore.vue
// module id = 8WPF
// module chunks = 1